import(/* webpackMode: "eager" */ "/codebuild/output/src1976537694/src/github.com/bitstone/offerz-nextjs/src/app/global-error.tsx");
